import formatInTimeZone from 'date-fns-tz/formatInTimeZone'

const convertToUTC = (
  dateTimeString: string,
  format = 'dd.MM.yyyy HH:mm',
): string => {
  return formatInTimeZone(new Date(dateTimeString), 'UTC', format)
}

export default convertToUTC
